const LEGACY_PROFILE_PATH_MAP = {
  "/profile": "",
  "/profile/matches": "/matches",
  "/profile/favorites": "/favorites",
  "/profile/collections": "/saved",
  "/profile/saved": "/saved",
  "/profile/setup": "/setup",
  "/profile/activity": "/activity",
  "/profile/notifications": "/notifications",
  "/profile/settings": "/settings",
  "/profile/messages": "/messages",
  "/profile/community/messages": "/messages",
  "/profile/community/requests": "/requests",
  "/profile/community/reviews": "/reviews",
  "/profile/community/answers": "/answers",
  "/profile/community/comments": "/comments",
  "/profile/shopping-model": "/settings",
  "/profile/savedsearches": "",
  "/profile/saved-searches": "",
  "/profile/blockedusers": "/settings",
  "/profile/reviews": "/reviews",
  "/profile/answers": "/answers",
  "/profile/comments": "/comments",
  "/profile/requests": "/requests",
  "/saved-searches": "",
};

const PROFILE_TAB_SUFFIXES = [
  "/matches",
  "/favorites",
  "/saved",
  "/setup",
  "/activity",
  "/recently-deleted",
  "/notifications",
  "/settings",
  "/messages",
  "/requests",
  "/reviews",
  "/answers",
  "/comments",
];

export const PROFILE_TAB_IDS = [
  "posts",
  "setup",
  "matches",
  "favorites",
  "saved",
  "activity",
  "recently-deleted",
  "notifications",
  "settings",
  "messages",
  "requests",
  "reviews",
  "answers",
  "comments",
];

export const OWN_ONLY_PROFILE_TABS = new Set([
  "matches",
  "favorites",
  "saved",
  "activity",
  "recently-deleted",
  "notifications",
  "settings",
  "messages",
  "requests",
  "reviews",
  "answers",
  "comments",
]);

export const getProfileTabFromPathname = (pathname, userId) => {
  if (!userId) return "posts";
  const base = `/user/${userId}`;
  const normalized = pathname.replace(/\/$/, "");
  if (normalized === base) return "posts";
  if (!normalized.startsWith(`${base}/`)) return "posts";
  const segment = normalized.slice(base.length + 1).split("/")[0];
  return segment || "posts";
};

export const isValidProfileTab = (tab) => PROFILE_TAB_IDS.includes(tab);

export const isOwnOnlyProfileTab = (tab) => OWN_ONLY_PROFILE_TABS.has(tab);

export const getUserProfilePath = (userId, suffix = "") => {
  if (!userId) return "/login";
  const normalized =
    suffix.startsWith("/") || suffix === "" ? suffix : `/${suffix}`;
  return `/user/${userId}${normalized}`;
};

export const getOwnProfilePath = (user, suffix = "") => {
  const userId = user?.id || user?._id;
  return getUserProfilePath(userId, suffix);
};

export const PROFILE_SECTION_ID = "profile-section";
export const PROFILE_SECTION_HASH = `#${PROFILE_SECTION_ID}`;

export const getOwnProfileSectionPath = (user, suffix = "") =>
  `${getOwnProfilePath(user, suffix)}${PROFILE_SECTION_HASH}`;

/**
 * Rewrites legacy /profile/* links to /user/:userId/* so clicks never bounce
 * through the old route shell.
 */
export const normalizeProfileUrl = (url, user) => {
  if (!url) return getOwnProfilePath(user);

  const userId = user?.id || user?._id;
  if (!userId) return url;

  try {
    const isAbsolute = url.startsWith("http://") || url.startsWith("https://");
    const parsed = isAbsolute ? new URL(url) : null;
    const pathname = (parsed ? parsed.pathname : url.split("?")[0]).replace(
      /\/$/,
      "",
    );
    const search = parsed
      ? parsed.search
      : url.includes("?")
        ? `?${url.split("?").slice(1).join("?")}`
        : "";

    if (pathname.startsWith("/user/")) {
      return isAbsolute ? parsed.href : `${pathname}${search}`;
    }

    let suffix = LEGACY_PROFILE_PATH_MAP[pathname];
    if (suffix === undefined && pathname.startsWith("/profile/community/")) {
      suffix = `/${pathname.replace("/profile/community/", "")}`;
    }
    if (suffix === undefined && pathname.startsWith("/profile")) {
      suffix = "";
    }
    if (suffix !== undefined) {
      const rewritten = getUserProfilePath(userId, suffix);
      return isAbsolute
        ? `${parsed.origin}${rewritten}${search}`
        : `${rewritten}${search}`;
    }

    if (PROFILE_TAB_SUFFIXES.includes(pathname)) {
      const rewritten = getUserProfilePath(userId, pathname);
      return isAbsolute
        ? `${parsed.origin}${rewritten}${search}`
        : `${rewritten}${search}`;
    }

    return url;
  } catch {
    return url;
  }
};
